module.exports = __webpack_public_path__ + "img/1588.3e74aa70.png";